import React from "react";
import styled from "styled-components";
import { Row, Col  } from "react-bootstrap";

import { hexToRGBA } from "../../../../../utils/theme";
import { FORM_FIELD_KEYS } from "../../../../../constants/forms";
import { getFieldProps } from "../../../../../utils/form-fields";

import TextInput from "../../../controls/TextInput";
import MaskInput from "../../../controls/MaskInput";
import Select from "../../../controls/Select";

const StyledContainer = styled.div`
  margin-bottom: 24px;
  border: 1px solid ${hexToRGBA('#000000', 0.1)};
  border-radius: 0.25rem;
`;

const StyledRow = styled(Row)`
  padding: 16px;
`;

function OwnerInfoBlock({ values = {}, onChange, onMouseEnter, onMouseLeave }) {
  return (
    <StyledContainer>
      <div className="inputs-block-title">
        <span>Owner Information</span>
      </div>
      <StyledRow>
        <Col xs={12} md={4}>
          <TextInput
            {...getFieldProps(FORM_FIELD_KEYS.ownerFirstName)}
            label={getFieldProps(FORM_FIELD_KEYS.ownerFirstName)?.placeholder?.replace("*", "")}
            placeholder={undefined}
            value={values[FORM_FIELD_KEYS.ownerFirstName]}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        </Col>
        <Col xs={12} md={4}>
          <TextInput
            {...getFieldProps(FORM_FIELD_KEYS.ownerMiddleName)}
            label={getFieldProps(FORM_FIELD_KEYS.ownerMiddleName)?.placeholder?.replace("*", "")}
            placeholder={undefined}
            value={values[FORM_FIELD_KEYS.ownerMiddleName]}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        </Col>
        <Col xs={12} md={4}>
          <TextInput
            {...getFieldProps(FORM_FIELD_KEYS.ownerLastName)}
            label={getFieldProps(FORM_FIELD_KEYS.ownerLastName)?.placeholder?.replace("*", "")}
            placeholder={undefined}
            value={values[FORM_FIELD_KEYS.ownerLastName]}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        </Col>
        <Col xs={12} md={4}>
          <Select
            {...getFieldProps(FORM_FIELD_KEYS.ownerTitle)}
            label={getFieldProps(FORM_FIELD_KEYS.ownerTitle)?.placeholder?.replace("*", "")}
            placeholder={getFieldProps(FORM_FIELD_KEYS.ownerTitle)?.placeholder?.replace("*", "")}
            value={values[FORM_FIELD_KEYS.ownerTitle]}
            validated={values.validated}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        </Col>
        <Col xs={12} md={4}>
          <Select
            {...getFieldProps(FORM_FIELD_KEYS.ownerSuffixName)}
            label={getFieldProps(FORM_FIELD_KEYS.ownerSuffixName)?.placeholder?.replace("*", "")}
            placeholder={getFieldProps(FORM_FIELD_KEYS.ownerSuffixName)?.placeholder?.replace("*", "")}
            value={values[FORM_FIELD_KEYS.ownerSuffixName]}
            validated={values.validated}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        </Col>
        <Col xs={12} md={4}>
          <MaskInput
            {...getFieldProps(FORM_FIELD_KEYS.ownerSSN)}
            label="Social Security Number"
            placeholder="123-45-6789"
            value={values[FORM_FIELD_KEYS.ownerSSN]}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            hideDivider
          />
        </Col>
      </StyledRow>
    </StyledContainer>
  );
}

export default OwnerInfoBlock;
